import { render } from "./page-login.vue?vue&type=template&id=51789404"
import script from "./page-login.vue?vue&type=script&lang=js"
export * from "./page-login.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\domin\\Desktop\\workspace\\hub-web-apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__